import { useState } from "react";
import Error from "../Layouts/Error";
import InnerHeader from "../Layouts/InnerHeader";
import Loading from "../Layouts/Loading";
import { Packages, useGetPackagesQuery } from "../Redux/Apis/utilApi";
import { fa_currency } from "../utils/Persian";
import { InvoicePay, useCreateByPackageMutation } from "../Redux/Apis/invoiceApi";

export default function Package() {
    const [selected,setSelected] = useState<Packages>()
    const [purchase, {isLoading : isPayLoading}] = useCreateByPackageMutation()
    const [link,setLink] = useState<InvoicePay>()
    const [errorMsg, setErrorMsg] = useState<any>(false)

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetPackagesQuery({})

    const Pay = async (id:any) => {
        try {
            const link = await purchase(+id).unwrap()
            if (link.url) {
                setLink(link)
                setErrorMsg(false)
                setTimeout(() => { 
                    window.location = link.url;
                }, 3000)
            }
            else {
                setErrorMsg("پرداخت با مشکل مواجع شد.")
            }
            
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess){
        return(
        <div className="container-lg">
            <InnerHeader name="پکیج ها"/>
            {errorMsg && <div className="alert alert-danger" role="alert">
                {errorMsg}
            </div>}
            <section className="section" id="pricing">
            <div className="container">
                <div className="row">
                    {!selected  && <div className="col-lg-12">
                        <div className="border p-2 rounded">
                            <h4 className="f-20"><i className="zmdi zmdi-check-square fs-2"></i> پکیج پایه</h4>
                            
                            <p className="text-muted f-17 mt-3 mb-3">    
                                پکیج پایه لینکت به صورت رایگان برای یکبار روی سرویس شما فعال میگردد. این پکیج شامل همه ویژگی های سرویس نقره ایی می باشد اما
                                دارای یک سری محدودیت می باشد که می توانید با توجه به نیاز خود با سایر سرویس ها ارتقا نمایید.
                            </p>
                            <button disabled className="btn btn-success float-end text-center">
                                <i className="zmdi zmdi-check-circle fs-3 me-2"></i>
                                <p className="m-0">پکیج پیشفرض</p>
                            </button>
                            <p className="mb-2">
                                <i className="zmdi zmdi-check-circle text-success f-18 me-2"></i>
                                امکانات پایه پکیج نقره ایی
                            </p>
                            <p className="mb-2">
                                <i className="zmdi zmdi-close-circle text-danger f-18 me-2"></i>
                                محدودیت بارگذاری ۵ تصویر
                            </p>
                            <p className="mb-2">
                                <i className="zmdi zmdi-close-circle text-danger f-18 me-2"></i>
                                دامنه ir رایگان ندارد (سابدامنه همچنان ارایه می گردد.)
                            </p>
                        </div>
                    </div>}
                    <div className="col-lg-12">
                        <div className="title-box text-center">
                            <h3 className="title-heading mt-4">انتخاب پکیج</h3>
                            <p className="text-muted f-17 mt-3 mb-3">
                            با توجه به نوع کاربری و قالب انتخابی خود میتوانید هرکدام از پکیج های ما را انتخاب نمایید.
                            </p>
                            <p className="text-primary f-17 mt-3 mb-3 shaky">
                               ( تمامی پکیج ها با ضمانت بازگشت وجه به مدت یک هفته در صورت عدم رضایت ارایه می گردد )
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {data && !selected && data.map((value:Packages,index:number) => 
                    <div className="col-lg-4" key={index}>
                        <div className="pricing-box mt-4">
                            
                            <h4 className="f-20"><i className="zmdi zmdi-pin-assistant fs-2"></i> پکیج {value.name}</h4>

                            <div className="mt-4 pt-2">
                                <p className="mb-2 f-18">ویژگی ها</p>

                                {value.pros && value.pros.split("،").map((prop_value:any,prop_index:number) => 
                                <p className="mb-2" key={prop_index}>
                                    <i className="zmdi zmdi-check-circle text-success f-18 me-2"></i>
                                    {prop_value}
                                </p>
                                )}
                                {value.cons && value.cons.split("،").map((cons_value:any,cons_index:number) => 
                                <p className="mb-2" key={cons_index}>
                                    <i className="zmdi zmdi-close-circle text-danger f-18 me-2"></i>
                                    {cons_value}
                                </p>
                                )}
                            </div>
                            <p className="mt-4 pt-2 text-muted">
                                {value.note}
                            </p>
                            <div className="pricing-plan mt-4 pt-2">
                            <h5 className="text-muted">
                                    {value.sale_price ?
                                    <>
                                        <s className="me-2">{fa_currency(+value.price)} ،تومان</s>
                                        <br />
                                        <span className="text-dark">{fa_currency(+value.sale_price)} ،تومان</span>
                                    </>
                                    :
                                        <span className="text-dark">{fa_currency(+value.price)} ،تومان</span>
                                    }
                                </h5>
                                <p className="text-muted mb-0">سالیانه</p>
                            </div>
                            <div className="mt-4 pt-3 text-end">
                                <button onClick={() => setSelected(value)} className="btn btn-primary btn-rounded">
                                    <i className="zmdi zmdi-check-square me-1"></i>
                                    {value.sale_price === 0 ?
                                    'فعال سازی رایگان'
                                    :
                                    'انتخاب پکیج ' + value.name
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                    )}
                    {selected && <div className="col-lg-12 text-center mt-2">
                    <div className="pricing-box mt-4">
                            
                            <h4 className="f-20"><i className="zmdi zmdi-pin-assistant fs-2"></i> خرید پکیج {selected.name}</h4>

                            <div className="mt-4 pt-2">
                                <p className="mb-2 f-18">ویژگی ها</p>

                                {selected.pros && selected.pros.split("،").map((prop_value:any,prop_index:number) => 
                                <p className="mb-2" key={prop_index}>
                                    <i className="zmdi zmdi-check-circle text-success f-18 me-2"></i>
                                    {prop_value}
                                </p>
                                )}
                                {selected.cons && selected.cons.split("،").map((cons_value:any,cons_index:number) => 
                                <p className="mb-2" key={cons_index}>
                                    <i className="zmdi zmdi-close-circle text-danger f-18 me-2"></i>
                                    {cons_value}
                                </p>
                                )}
                            </div>
                            <p className="mt-4 pt-2 text-muted">
                                {selected.note}
                            </p>
                            <div className="pricing-plan mt-4 pt-2">
                            <h5 className="text-muted">
                                    {selected.sale_price ?
                                    <>
                                        <s className="me-2">{fa_currency(+selected.price)} ،تومان</s>
                                        <br />
                                        <span className="text-dark">{fa_currency(+selected.sale_price)} ،تومان</span>
                                    </>
                                    :
                                        <span className="text-dark">{fa_currency(+selected.price)} ،تومان</span>
                                    }
                                </h5>
                                <p className="text-muted mb-0">سالیانه</p>
                            </div>
                        </div>

                        <br />
                        <div className="d-grid gap-2 d-md-block">
                            <button className="btn btn-outline-secondary me-2" onClick={() => setSelected(undefined)}>بازگشت به پکیج ها</button>
                            {!link && <button onClick={() => Pay(selected.id)} disabled={isPayLoading} className="btn btn-success">خرید این پکیج</button>}
                            {link && <button onClick={() => window.location = link.url} type="button" className="btn btn-primary">
                                <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
                                هدایت به درگاه...
                            </button>}
                        </div>
                    </div>}
                </div>
            </div>
        </section>
        </div>
    )}

    else return <></>
}